import data from "../../../../../src/CounterLabel.docs.json";
import * as React from 'react';
export default {
  data,
  React
};